import { NullableClassName } from '@squareup/dex-types-shared-ui';
import { Link } from '@squareup/dex-ui';
import { Paragraph20 } from '@squareup/dex-ui-shared-base';
import { MarkdownLink } from '@squareup/dex-ui-shared-markdown-components';
import React, { ReactNode } from 'react';

type ReferenceGuideProps = {
  title: string;
  content: ReactNode | undefined;
  linkProps?: {
    href: React.ComponentProps<typeof Link>['href'] | undefined;
    trackingId: string;
  };
  topMargin?: boolean | undefined;
} & NullableClassName;

const ReferenceGuide = ({
  title,
  linkProps,
  content,
  topMargin,
}: ReferenceGuideProps) => {
  return (
    <>
      <Paragraph20
        margin={{ bottom: '0.5x', top: topMargin ? '2x' : undefined }}
        weight="medium"
      >
        {title}
      </Paragraph20>
      {linkProps && linkProps.href ? (
        <Paragraph20 weight="medium">
          <MarkdownLink
            href={linkProps.href.toString()}
            trackingId={linkProps.trackingId}
          >
            {content}
          </MarkdownLink>
        </Paragraph20>
      ) : (
        <Paragraph20 colorVariant="10">{content}</Paragraph20>
      )}
    </>
  );
};

export { ReferenceGuide, type ReferenceGuideProps };
